exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumb {\n  display: inline-block; }\n\n.card {\n  margin: 0;\n  padding: 0; }\n\n.image-wrap {\n  position: relative;\n  display: inline-block; }\n  .image-wrap .btn {\n    position: absolute;\n    top: 0;\n    right: 0; }\n\n.input-group {\n  margin: 1rem 0; }\n  .input-group label {\n    padding-right: 1rem; }\n\n.pl-1 {\n  padding-left: 1rem; }\n\n.p-0 {\n  padding: 0; }\n\nlabel {\n  font-weight: 700; }\n\n.fullscreen {\n  position: absolute;\n  display: block;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/news/news-details/news-details.component.scss
// module id = 974
// module chunks = 1